<template>
  <v-row justify="center">
    <v-dialog v-model="open" persistent :max-width="width">
      <v-card>
        <v-card-title class="headline">{{title}}</v-card-title>
        <v-card-text>
          <p class="body-2">Use the drag handles to reorder the prompt questions.</p>
          <draggable v-model="prompts.config" @start="drag=true" @end="drag=false" :move="onMove">
            <v-list-item
              v-for="(item, index) in prompts.config"
              :key="index"
              :disabled="isEnforcedPrompt.indexOf(item) !== -1"
            >
              <v-list-item-icon>
                <v-icon class="drag-handle">mdi-drag</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>{{item | title_case}}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </draggable>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" outlined @click="set()">Set</v-btn>
          <v-btn color="grey" outlined @click="cancel()">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import draggable from "vuedraggable";

export default {
  data() {
    return {
      prompts: this.value,
      isEnforcedPrompt: [],
    };
  },
  created() {},
  mounted() {
    this.setEnforcedPromptOrder();
  },
  computed: {},
  methods: {
    onMove(evt) {
      let promptElementSubject = evt.draggedContext.element;
      let promptElementTarget = evt.relatedContext.element;
      let isEnforced = this.enforcedPromptOrder.find(
        (epo) =>
          epo.prompt === promptElementSubject ||
          epo.prompt === promptElementTarget
      );
      return isEnforced ? false : true;
    },
    set() {
      if (typeof this.setCallback === "function") {
        this.setCallback();
      }

      this.$emit("update:open", false);
    },
    cancel() {
      this.$emit("update:open", false);
    },
    movePrompt(prompt, toIndex) {
      let fromIndex = this.prompts.config.indexOf(prompt);
      if (fromIndex === -1 || fromIndex === toIndex) return false;

      let element = this.prompts.config[fromIndex];
      this.prompts.config.splice(fromIndex, 1);
      this.prompts.config.splice(toIndex, 0, element);
      return true;
    },
    setEnforcedPromptOrder(changed) {
      let wasMoved = false;
      this.isEnforcedPrompt = [];

      if (this.enforcedPromptOrder && this.enforcedPromptOrder.length) {
        for (let index = 0; index < this.enforcedPromptOrder.length; index++) {
          const promptOrder = this.enforcedPromptOrder[index];
          wasMoved = wasMoved || this.movePrompt(promptOrder.prompt, promptOrder.index);
          this.isEnforcedPrompt.push(promptOrder.prompt);
        }

        if (changed && wasMoved && typeof this.setCallback === "function") {
          this.setCallback();
        }
      }
    },
  },
  watch: {
    enforcedPromptOrder(now, before) {
      if (now && now !== before) {
        this.setEnforcedPromptOrder(true);
      }
    },
  },
  components: {
    draggable,
  },
  props: {
    open: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "Prompt Order",
    },
    value: {
      type: [Array, Object],
      default: () => {
        return null;
      },
    },
    setCallback: {
      type: Function,
    },
    enforcedPromptOrder: {
      type: Array,
      default: () => {
        return [];
      },
    },
    width: {
      type: [Number, String],
      default: 300,
    },
  },
};
</script>

<style lang="scss" scoped>
.drag-handle {
  cursor: grab;
}
</style>